import ctl from '@netlify/classnames-template-literals';

export const containerStyle = ctl(`
  w-full
  mb-5
`);

export const detailsContainerStyle = ctl(`
  flex 
  flex-col 
  gap-6
`);

export const headerStyle = ctl(`
  flex 
  items-top 
  justify-between 
  max-w-[750px] 
  my-5
`);

export const menuClasses = {
  container: 'h-full',
};

const commonBtnStyles = ctl(`
  offset-base
  bg-ghost-white 
  w-full
  text-left
  rounded-full
  px-4
  py-2
  text-base
`);

export const activateBtnStyle = ctl(`
  ${commonBtnStyles}
  text-green-ncs
`);

export const archiveBtnStyle = ctl(`
  ${commonBtnStyles}
  text-orange-soda
`);

export const archivemenuContainerStyle = ctl(`
  relative
  inline-block
  flex
  align-items: center
`);
